import { createSingleEntityStore, ngrxEvent } from '@core/ngrx-legacy';

import type { TellentSso, TellentSsoAppRole, TellentSsoSwitchableMode } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<TellentSso | null>()(
  'tellentSso',
  {
    customActions: adapter => ({
      replaceXml: ngrxEvent<{ file: File; code: string | null }>(),
      replaceXmlSuccess: ngrxEvent<TellentSso>(),
      replaceXmlFailure: ngrxEvent<{ error: string }>(),
      uploadXml: ngrxEvent<{ file: File; entityId?: string }>(),
      uploadXmlSuccess: ngrxEvent<TellentSso>(),
      uploadXmlFailure: ngrxEvent<{ error: string }>(),
      updateRoles: ngrxEvent<{
        roles: TellentSsoAppRole[];
        entityId?: string;
      }>(),
      updateRolesSuccess: ngrxEvent<{ defaultSeats: TellentSsoAppRole[]; entityId?: string }>(),
      updateRolesFailure: ngrxEvent<any>(),
      delete: ngrxEvent<string>(),
      deleteSuccess: ngrxEvent<void>(),
      deleteFailure: ngrxEvent<any>(),
      changeMode: ngrxEvent<{ code: string; mode: TellentSsoSwitchableMode }>(),
      changeModeSuccess: ngrxEvent<void>(),
      changeModeFailure: ngrxEvent<any>(),
      changeSessionLength: ngrxEvent<{ code: string; tokenExpirationHours: number }>(),
      changeSessionLengthSuccess: ngrxEvent<void>(),
      changeSessionLengthFailure: ngrxEvent<any>(),
    }),
  },
);

export {
  actions as TellentSsoActions,
  reducer as TellentSsoReducer,
  selectors as TellentSsoSelectors,
  namespace as TellentSsoNamespace,
};
